document.addEventListener("DOMContentLoaded", () => {
  const content = document.getElementById("description-content");
  const text = document.getElementById("description-text");
  const expandLink = document.getElementById("expand-link");

  // Only run if all elements are found
  if (!content || !text || !expandLink) return;

  // Add toggle behavior
  expandLink.addEventListener("click", (event) => {
    event.preventDefault(); // prevent anchor jump

    if (expandLink.textContent.trim() === "Vis mer") {
      expandLink.textContent = "Vis mindre";
      text.classList.remove("text-clip");
    } else {
      expandLink.textContent = "Vis mer";
      text.classList.add("text-clip");
    }
  });

  // Detect overflow and show/hide the link
  if (text.scrollHeight > content.offsetHeight) {
    expandLink.style.display = "inline";
  } else {
    expandLink.style.display = "none";
  }
});
